const forEach = require("lodash").forEach;

let coreFields = require.context("./products", true, /index\.js$/);

export default {
    install(Vue, option) {
        forEach(coreFields.keys(), (key) => {
            if (coreFields(key)?.default?.install){
                Vue.use(coreFields(key).default);
            }
        });
    }
};